function getCsrfToken() {
    var name = 'csrf_splunkbase_token';
    if (document.cookie) {
        var cookies = document.cookie.split(';');
        var i;
        for (i = 0; i < cookies.length; i += 1) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length) === name) {
                var csrf = cookie.substring(name.length + 1);
                return csrf;
            }
        }
    }
    return '';
}

(class extends u.BaseElement {
    createdCallback() {
        let strDate = this.getAttribute('sb-date');
        let localDate = new Date(Date.parse(strDate));
        const span = document.createElement('span');
        let convertedDate = localDate.toDateString() + ' ' +
                         localDate.toLocaleTimeString() + ' ' +
                         localDate.toString().match(/\(([A-Za-z\s].*)\)/)[1];
        span.innerHTML = convertedDate;
        this.appendChild(span);
    }
}).register('sb-local-date');

sb.reCaptcha = class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.siteKey = this.getAttribute('sitekey');
        this.$init();
    }

    $init() {
        sb.reCaptcha.widgets.push(this);

        if(window.reCaptchaOnload === undefined) {
            window.reCaptchaOnload = function () {
                let recaptcha = window.grecaptcha;
                for(let widget of sb.reCaptcha.widgets) {
                    recaptcha.render(
                        widget.id, {
                            sitekey: widget.siteKey,
                            callback: widget.$responseCallback.bind(widget)
                        });
                }
            };
        }
    }

    $responseCallback(response) {
        var event = new CustomEvent('sb-captcha-success', {
            detail: {
                id: this.id,
                response: response
            }
        });
        document.dispatchEvent(event);
    }
};
sb.reCaptcha.widgets = [];
sb.reCaptcha.register('sb-captcha');

(class extends u.AnchorElement {
    createdCallback () {
        // if user is anonymous
        if (context.username === null) {
            var loginUrl = context.login_sso;
            // var loginUrl = 'https://' + context.login_sdc + '/index.php?module=roles&func=showloginform&redirecturl=';
            this.setAttribute('href', loginUrl + encodeURIComponent(window.location))
        }
    }
}).register('sb-auth-required');

(class extends u.BaseElement {
    createdCallback() {
        if (!context.is_directory_listing) {
            this.innerHTML = '"' + context.app_name + '" is not a directory listing. No action taken.';
        }
        else {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `/api/v0/app/${context.appid}/validate_url/`);
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    this.innerHTML = xhr.responseText;
                }
            }
            xhr.send();
        }
    }
}).register('sb-validate-url');
